import React, { useEffect, useState } from 'react'

const konamiCode = [38, 38, 40, 40, 37, 39, 37, 39, 66, 65]

const TriviaButton: React.FC = () => {
  const [isVisible, setIsVisible] = useState<boolean>(false)
  const [, setInputSequence] = useState<number[]>([])
  const [currentTrivia, setCurrentTrivia] = useState<string>('')

  const triviaFacts = [
    'Did you know? Cardano is named after Gerolamo Cardano, an Italian mathematician known for his work in algebra.',
    "Did you know? Ada Lovelace, considered the first computer programmer, is the namesake of Cardano's native cryptocurrency, ADA.",
    'Did you know? Cardano uses a unique proof-of-stake algorithm called Ouroboros, making it more energy-efficient than traditional proof-of-work blockchains.',
    'Did you know? Charles Hoskinson, a co-founder of Ethereum, founded Cardano to create a more scalable and sustainable blockchain platform.',
    "Did you know? Cardano's development is guided by academic research and peer-reviewed papers, ensuring a solid scientific foundation.",
    'Did you know? Cardano is built using Haskell, a functional programming language known for its robustness and security.',
    'Did you know? The Cardano blockchain consists of two layers: the Cardano Settlement Layer (CSL) for transactions and the Cardano Computation Layer (CCL) for smart contracts.',
    'Did you know? Cardano aims to provide financial services to the unbanked populations in developing countries.',
    'Did you know? The Cardano Foundation, IOHK, and EMURGO are the three organizations responsible for the development and promotion of Cardano.',
    "Did you know? Cardano's treasury system allocates a portion of transaction fees to fund future development projects, ensuring sustainability.",
    "Did you know? Cardano's staking model allows ADA holders to delegate their tokens to a stake pool and earn rewards.",
    "Did you know? Cardano's Plutus platform allows developers to write smart contracts in Haskell, leveraging its strong type system and formal verification.",
    "Did you know? Cardano's Marlowe language is designed for financial smart contracts, enabling non-programmers to create and execute contracts with ease.",
    "Did you know? Cardano's governance model allows ADA holders to participate in decision-making processes, giving the community a voice in its future direction.",
    'Did you know? Cardano has a strong focus on interoperability, aiming to connect with other blockchains and legacy financial systems.',
    "Did you know? Cardano's blockchain is designed to be scalable, secure, and decentralized, addressing the limitations of earlier blockchain platforms.",
    "Did you know? Cardano's native cryptocurrency, ADA, is named in honor of Ada Lovelace, who wrote the first algorithm intended for a machine.",
    "Did you know? Cardano's development team includes experts in cryptography, engineering, and blockchain technology from around the world.",
    "Did you know? Cardano's approach to security includes formal methods and high-assurance code, ensuring a high level of trust and reliability.",
    "Did you know? Cardano's Alonzo upgrade brought smart contract functionality to the platform, enabling a wide range of decentralized applications.",
  ]

  useEffect(() => {
    const handleKeydown = (event: KeyboardEvent) => {
      const key = event.keyCode
      setInputSequence((prevSequence: number[]) => {
        const newSequence = [...prevSequence, key]
        if (
          newSequence.slice(-konamiCode.length).join(',') ===
          konamiCode.join(',')
        ) {
          window.scrollTo({ top: 0, behavior: 'smooth' })
          setIsVisible(true)
        }
        return newSequence
      })
    }

    window.addEventListener('keydown', handleKeydown)

    return () => {
      window.removeEventListener('keydown', handleKeydown)
    }
  }, [])

  const handleMouseEnter = () => {
    const randomTrivia =
      triviaFacts[Math.floor(Math.random() * triviaFacts.length)]
    setCurrentTrivia(randomTrivia)
  }

  return (
    isVisible && (
      <div className="group relative">
        <button
          className="transform rounded-full bg-[#0538af] px-4 py-2 font-bold text-white shadow-lg transition duration-300 ease-in-out hover:-translate-y-1"
          style={{ zIndex: 1000 }}
          onMouseEnter={handleMouseEnter}
        >
          🚀 Cardano Trivia 🌟
        </button>
        <div className="animated-trivia-tooltip absolute left-1/2 top-full mb-2 w-96 -translate-x-1/2 transform rounded-md p-2 text-center text-lg text-white opacity-0 shadow-lg transition-opacity duration-300 group-hover:opacity-100">
          {currentTrivia}
        </div>
      </div>
    )
  )
}

export default TriviaButton
